import { createFileRoute } from '@tanstack/react-router'
import { PassBuilderScreen } from '@/features/passes/pass-builder-screen'

export const Route = createFileRoute('/_app/passes')({ component: PassBuilderScreen })
